import './app.css';
import 'babel-polyfill';



/* is production */
const isProd = process.env.NODE_ENV === 'production';



/* meta */
const meta = require('./js/meta.json');

/* data [UNCOMMENT THE LINE BELOW TO USE TEXTS FROM DATA IN JS] */
// const data = require('./js/data.json');



/* analytics */
/* SEND EVENT: analyticsEvent('Button', 'click', {eventLabel: 'Play'}); */
const analytics = require('universal-ga');

analytics.initialize(meta.trackingID);
analytics.pageview('/index');

if (meta.clientTrackingID.length > 0) {
    analytics.create(meta.clientTrackingID, 'clientTracker');
    analytics.name('clientTracker').pageview('/index');
}

window.analyticsEvent = (category, action, options) => {
    analytics.event(category, action, options);

    if (meta.clientTrackingID.length > 0) {
        analytics.name('clientTracker').event(category, action, options);
    }
};

/* EXAMPLE */
analyticsEvent('Page', 'load', {eventLabel: 'Successfully'});



/* fonts */
const WebFont = require('webfontloader');

WebFont.load({
    google: {
        families: ['PT+Sans:400,700']
    }
});



/* share */
import * as VanillaSharing from 'vanilla-sharing';

const shareButtons = [...document.querySelectorAll('.share__item')];

if (shareButtons.length > 0) {

    const shareOptions = {
        url: meta.url,
        title: meta.title,
        description: meta.description,
        image: meta.image,
        isVkParse: false,
        fbAppId: meta.fbappid
    };

    shareButtons.forEach(button => {
        button.addEventListener('click', () => {
            VanillaSharing[button.dataset.social](shareOptions);

            analyticsEvent('Share', 'click', {eventLabel: 'Social: ' + button.dataset.social});
        });
    });

}



/* service worker */
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js');
    });
}



/* jquery [UNCOMMENT THE LINE BELOW TO USE JQUERY IN JS] */
// window.$ = window.jQuery = require('jquery');

// createjs -> is Global
require('latest-createjs');


require('./js/main.js');





// console.log(elem);




// WEBPACK FOOTER //
// ./app.js